export const ARC_START = 250;
export const ARC_END = 110;
export const DEFAULT_DECIMALS = 2;
